import facultyConnectService from "../../apiServices/faculty/facultyConnectService";
import { setFacultyConnectClassDetails } from "../../store/slices/faculty/facultyConnectClassSlice";
import { setFacultyConnectDetails } from "../../store/slices/faculty/facultyConnectSlice";

export function getFacultyConnectDetails(id: number) {
  return async function (dispatch: any, getState: any) {
    let response = await facultyConnectService.getFacultyConnectDetails(id);
    if (response?.success === true) {
      dispatch(setFacultyConnectDetails(response.data));
    } else {
      console.log("error");
    }
  };
}

export function getFacultyConnectClassDetails() {
  return async function (dispatch: any, getState: any) {
    let response = await facultyConnectService.getFacultyClassDetails();
    if (response?.success === true) {
      dispatch(setFacultyConnectClassDetails(response.data));
    } else {
      console.log("error");
    }
  };
}
